import SkeletonHabitPackCard from './SkeletonHabitPackCard';

interface SkeletonHabitPackListProps {
  count?: number;
  className?: string;
}

const DEFAULT_HABIT_PACK_SKELETON_COUNT = 6;

const SkeletonHabitPackList = ({
  count = DEFAULT_HABIT_PACK_SKELETON_COUNT,
  className = ''
}: SkeletonHabitPackListProps) => (
  <div
    className={`w-full h-fit flex flex-col items-center ~p-1/2 ~gap-4/6 ${className}`}
    data-testid='skeleton-habit-pack-list'>
    {Array.from({ length: count }).map((_, index) => (
      <SkeletonHabitPackCard key={index} />
    ))}
  </div>
);

export default SkeletonHabitPackList;
